import { render, staticRenderFns } from "./CandelaComponent.vue?vue&type=template&id=6f9de920&"
import script from "./CandelaComponent.vue?vue&type=script&lang=js&"
export * from "./CandelaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports